import React from 'react';

const badgePositionStyles = {
  'top-left': 'top-4 left-4',
  'top-right': 'top-4 right-4',
  'bottom-left': 'bottom-4 left-4',
  'bottom-right': 'bottom-4 right-4',
  'bottom-center': 'bottom-4 left-1/2 -translate-x-1/2',
};

export default function AchievementSlide({ image, text, badgePosition = 'top-left', imageHeight = '100%' }) {
  return (
    <div className="relative flex items-end justify-center w-full h-full">
      <img
        src={image}
        alt={text}
        className="w-full object-cover rounded-[20px]"
        style={{ height: imageHeight, maxHeight: imageHeight }}
      />
      <span
        className={`absolute ${badgePositionStyles[badgePosition] || badgePositionStyles['top-left']} bg-white text-black text-base font-medium px-4 py-1 rounded-full shadow-lg whitespace-nowrap z-20 flex flex-col items-center`}
        style={{ boxShadow: '0 2px 12px 0 rgba(0,0,0,0.10)' }}
      >
        {/* Arrow for tooltip effect */}
        {badgePosition.startsWith('bottom') && (
          <svg width="18" height="10" viewBox="0 0 18 10" className="absolute -top-2 left-1/2 -translate-x-1/2" style={{ zIndex: 1 }}><polygon points="9,0 18,10 0,10" fill="white" /></svg>
        )}
        <span className="relative z-10 text-sm md:text-base">{text}</span>
        {badgePosition.startsWith('top') && (
          <svg width="18" height="10" viewBox="0 0 18 10" className="absolute -bottom-2 left-1/2 -translate-x-1/2" style={{ zIndex: 1 }}><polygon points="0,0 18,0 9,10" fill="white" /></svg>
        )}
      </span>
    </div>
  );
} 